import React, { CSSProperties } from 'react'
import cn from 'classnames'
import ButtonIcon from '../ButtonIcon'
import { observer } from 'mobx-react'
import { useStore } from 'store'

import { UseFormRegister } from 'react-hook-form/dist/types/form'
import { FieldErrors } from 'react-hook-form/dist/types/errors'
import { IUser } from 'models'

import UserInfoInput from 'components/UserInfoInput'

import styles from './styles.module.scss'

interface ICustomStyleButton {
  type: string
  icon:
    | 'facebook'
    | 'twitter'
    | 'telegram'
    | 'google'
    | 'git'
    | 'linkedIn'
    | 'reddit'
    | 'instagram'
  styleIcon: CSSProperties
}

const customStyleButton: ICustomStyleButton[] = [
  { type: 'FacebookLink', icon: 'facebook', styleIcon: { width: 8, height: 16 } },
  { type: 'TwitterLink', icon: 'twitter', styleIcon: { width: 14, height: 11 } },
  { type: 'TelegramLink', icon: 'telegram', styleIcon: { width: 15, height: 13 } },
  { type: 'LinkedInLink', icon: 'linkedIn', styleIcon: { width: 14, height: 14 } },
  { type: 'RedditLink', icon: 'reddit', styleIcon: { width: 14, height: 14 } },
  { type: 'GitLink', icon: 'git', styleIcon: { width: 14, height: 14 } },
  { type: 'InstagramLink', icon: 'instagram', styleIcon: { width: 16, height: 16 } }
]

interface IProps {
  user: IUser
  edit: boolean
  register: UseFormRegister<any>;
  errors: FieldErrors
}

const SocialLink: React.FC<IProps> = observer(({ user, edit, register, errors }) => {
  const { mediaQuery } = useStore()

  let {
    FacebookLink,
    TelegramLink,
    TwitterLink,
    LinkedInLink,
    RedditLink,
    GitLink,
    InstagramLink
  } = user

  const onOpenLink = (link: string) => {
    const win = window.open(link, '_blank')
    if (win) {
      win.focus()
    }
  }

  const getSocialBlock = (type: string, value: string) => {
    let buttonStyle = customStyleButton.find(v => v.type === type)

    if (edit || (!edit && value)) {
      return (
        <div
          className={cn({
            [styles.container]: true,
            [styles.errorContainer]: !!errors[type]?.message
          })}
        >
          <ButtonIcon
            onClick={() => {
              onOpenLink(value)
            }}
            dark
            icon={buttonStyle?.icon}
            style={{ margin: '0 10px 0 0' }}
            styleIcon={buttonStyle?.styleIcon}
          />
          {edit && (
            <UserInfoInput
              edit={true}
              register={register}
              placeholder={'Link goes here...'}
              name={type}
              value={value}
              error={errors[type]?.message}
              styleErrorIcon={
                {
                  padding: 0,
                  width: '16px',
                  height: '16px',
                  right: '10px',
                  bottom: mediaQuery.minWidth_2200 ? '10px' : '6px'
                }}
            />
          )}
        </div>
      )
    }
  }

  if (!FacebookLink && !TwitterLink && !TelegramLink  && !LinkedInLink && !RedditLink && !GitLink && !InstagramLink && !edit) return null

  return (
    <div className={styles.body}>
      <div
        className={cn({
          [styles.buttons]: true,
          [styles.buttonsEdit]: edit
        })}
      >
        {getSocialBlock('FacebookLink', FacebookLink)}
        {getSocialBlock('TwitterLink', TwitterLink)}
        {getSocialBlock('TelegramLink', TelegramLink)}
        {getSocialBlock('LinkedInLink', LinkedInLink)}
        {getSocialBlock('RedditLink', RedditLink)}
        {getSocialBlock('GitLink', GitLink)}
        {getSocialBlock('InstagramLink', InstagramLink)}
      </div>
    </div>
  )
})

export default SocialLink
